import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';
import { BaseRouteEnum } from '../enums/route/base-route.enum';
import { QuickQuoteRouteEnum } from '../enums/route/quick-quote-route.enum';

/**
 * Guard to check if user is active.
 */
@Injectable({
  providedIn: 'root'
})
export class IsUserActiveGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const routePath = route.routeConfig?.path;
    const urlPath = this.router.url;
    const isQuickQuoteRoute =
      routePath === QuickQuoteRouteEnum.QUICK_QUOTE || urlPath.includes(`/${QuickQuoteRouteEnum.QUICK_QUOTE}`);

    // Block AdvicePlus users from accessing DIP and FullApp routes
    if (this.authService.isAdvicePlus && !isQuickQuoteRoute) {
      return this.router.createUrlTree([BaseRouteEnum.EMPTY]);
    }

    // Allow Advice+ brokers to access the QQ page regardless of active status
    // For other routes, require active status
    if (this.authService.isUserActive || (this.authService.isAdvicePlus && isQuickQuoteRoute)) {
      return true;
    }
    return this.router.createUrlTree([BaseRouteEnum.EMPTY]);
  }
}
